/* =====================================================================
   v2 — Yardım Merkezi makalesi: paylaş butonu
   navigator.share varsa yerel paylaşım sayfasını açar; yoksa bağlantıyı
   panoya kopyalar ve butonun etiketini kısa süreliğine "Kopyalandı" yapar.
   ===================================================================== */
(function () {
  function copy(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    /* clipboard API yoksa (http, eski tarayıcı) geçici bir alanla kopyala */
    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      var done = false;
      try {
        done = document.execCommand('copy');
      } catch (error) {
        done = false;
      }
      document.body.removeChild(field);
      if (done) resolve();
      else reject(new Error('copy failed'));
    });
  }

  function bind(button) {
    if (button.dataset.v2HaShareBound === 'true') return;
    button.dataset.v2HaShareBound = 'true';

    var url = button.dataset.v2HaShare;
    var label = button.querySelector('[data-v2-ha-share-label]');
    var idle = label ? label.textContent : '';
    var copied = button.dataset.labelCopied || idle;
    var timer;

    button.addEventListener('click', function () {
      if (navigator.share) {
        navigator.share({ title: document.title, url: url }).catch(function () {
          /* kullanıcı vazgeçti — sessiz geç */
        });
        return;
      }
      copy(url).then(
        function () {
          if (!label) return;
          label.textContent = copied;
          clearTimeout(timer);
          timer = setTimeout(function () {
            label.textContent = idle;
          }, 2000);
        },
        function () {
          /* kopyalanamadıysa adres çubuğu zaten elinde — bir şey yapma */
        }
      );
    });
  }

  function init(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-v2-ha-share]'), bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
